const sort = {
    ascend: 'asc',
    descend: 'desc',
};

export default sort;
